import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router";
import {
  Col,
  Container,
  Row,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Button,
} from "reactstrap";
import ClickHere from "../assets/img/clickhere.png";
import { useSelector, useDispatch } from "react-redux";
import { getAtheletes } from "../store/actions/athleteActions";
import { toast } from "react-toastify";
import { fetchCollegeStates } from "../store/actions/athleteActions";
import { fetchSchoolStates } from "../store/actions/athleteActions";
import InstantChatModal from "../components/InstantChatModal";
import ArrangeChatAppointmentModal from "../components/ArrangeChatAppointmentModal";
import { Link } from "react-router-dom/cjs/react-router-dom";

function SearchForPlayer({ athleteId }) {
  let history = useHistory();
  let athlete = useSelector((state) => state.athlete);
  const { schoolStates, collegeStates } = useSelector((state) => state.athlete);

  useEffect(() => {
    if (athleteId) {
      setId(athleteId);
    }
  }, []);
  let dispatch = useDispatch();
  const [athletes, setAthletes] = useState([]);
  const [id, setId] = useState("");
  const [searchByName, setSearchByName] = useState("");
  const [state, setState] = useState("");
  useEffect(() => {
    if (collegeStates.length == 0) {
      dispatch(fetchCollegeStates());
    }
    if (schoolStates.length == 0) {
      dispatch(fetchSchoolStates());
    }
    localStorage.removeItem("teamId");
    localStorage.removeItem("uniqData");
    localStorage.removeItem("ByteamID");
    dispatch(getAtheletes());
  }, []);
  if (athletes.length > 0) {
    const uniq = [...new Set(athletes)];
    if (uniq.length > 0) {
      history.push({
        pathname: "/search-player/filter-player",
        state: {
          uniq,
          id,
          state,
        },
      });
    }
  }
  const [isShow, setIsShow] = useState(false);
  const toggleInstantChat = () => {
    setIsShow(!isShow);
  };
  const [isShowAppointment, setIsShowAppointment] = useState(false);
  const toggleInstantChatAppointment = () => {
    setIsShowAppointment(!isShowAppointment);
  };

  const searchButtonRef = useRef(null);

  useEffect(() => {
    if (athleteId && searchButtonRef.current) {
      setId(athleteId);
      setTimeout(() => {
        searchButtonRef.current.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  }, [athleteId]);

  return (
    <>
      <Container fluid className="mb-5">
        <Row className=" justify-content-center ">
          <Col lg="12" sm="12">
            <div className="complaint-card">
              <div className="d-flex justify-content-between flex-row-reverse align-items-center p-4 text-center text-md-left">
                <p className="dashboard-note-text mb-0">
                  For booking a CHAT lesson, we enter the Registration Number of
                  teacher-athlete whom fan wishes to hire (not entering the
                  name). Name appears as double-check. To help fan, we give
                  reminder notice where to find Registration number
                </p>
              </div>
              <div className="px-4">
                <Row>
                  <Col xs={12} md={3} className="text-center mb-3 mb-md-0">
                    <Button
                      color="primary"
                      onClick={() => toggleInstantChat()}
                      className="w-100"
                    >
                      ARRANGE <br /> INSTANT CHAT
                    </Button>
                  </Col>
                  <Col
                    xs={12}
                    md={6}
                    className="p-0 px-3 px-md-2 mb-3 mb-md-0 text-center text-md-left"
                  >
                    <p className="font-weight-bold text-small mb-0">
                      NOTE: After booking chat and ascrowing funds, Users have
                      up to 1 week to complete chat.Users can email each other
                      to change chat schedule or to choose the platform they
                      mutually prefer for their chat, such as Skype, Zoom,
                      FaceTime, What'sApp, Google Duo, Facebook Messenger, etc.
                    </p>
                  </Col>
                  <Col xs={12} md={3} className="text-center">
                    <Button
                      color="primary"
                      onClick={() => toggleInstantChatAppointment()}
                      className="w-100"
                    >
                      Arrange chat by <br /> Appointment
                    </Button>
                  </Col>
                </Row>
              </div>
              <div className="px-4 text-center text-md-left mt-3">
                <p className="dashboard-note-text">
                  NOTE: Fan and Athlete can communicate with each other by email
                  about time zones or if adjustment to the chat schedule is
                  needed.TIMELY connecting a video chat is best done with
                  Fan/Athlete cooperation using email messages.
                </p>
              </div>
              <div className="complaint-form pt-0">
                <p className="dashboard-title mt-0 ml-0 text-center w-100">
                  "SEARCH for athlete for Chat"
                </p>
                <div className="d-flex justify-content-center align-items-center w-100 mb-3">
                  <Link
                    to="/home"
                    className="text-white text-decoration-none width-res"
                  >
                    <Button color="primary" className="w-100">
                      Back To INFO Page
                    </Button>
                  </Link>
                </div>
                <h4 className="mb-3 dashboard-subtitle text-warning text-center">
                  For the group chat, Fan needs to add Athlete in his Favorite
                  list.
                </h4>
                <Row className="mt-5 align-items-center">
                  <Col xs={12} md={6} className="text-center mb-4 mb-md-0">
                    <InputGroup className="custom-input-group">
                      <InputGroupText>
                        <i className="fa fa-search"></i>
                      </InputGroupText>
                      <Input
                        className="ml-2"
                        value={id}
                        onChange={(e) => {
                          setId(e.target.value);
                          setState("");
                          setSearchByName("");
                        }}
                      />
                    </InputGroup>
                    <Label className="main-subtitle ml-0 mt-2 mb-2 d-block">
                      Find By Registration #
                    </Label>
                  </Col>
                  <Col xs={12} md={6} className="text-center text-md-start">
                    <h5>
                      Not sure of registration number of your favorite athlete?
                      Find it at page called{" "}
                      <a
                        href="https://fhp-fans.web.app/fan/search-player"
                        target="_blank"
                        className="text-dark"
                        rel="noopener noreferrer"
                      >
                        <span className="font-weight-bold">
                          Search for Player.
                        </span>
                      </a>
                    </h5>
                  </Col>
                </Row>
                <Row>
                  <Col md="6" align="center" className="mt-md-0 mt-2">
                    {id != "" &&
                      (athlete.athletes.length > 0 &&
                      athlete?.athletes?.filter(
                        (ath) => ath.athleteID == id && !ath.blocked
                      ).length > 0 ? (
                        <h4 className="text-success">
                          {
                            athlete?.athletes?.filter(
                              (ath) => ath.athleteID == id
                            )[0].first_name
                          }{" "}
                          {
                            athlete?.athletes?.filter(
                              (ath) => ath.athleteID == id
                            )[0].last_name
                          }
                        </h4>
                      ) : (
                        <p className="text-danger">No Player Found!</p>
                      ))}
                    <Button
                      innerRef={searchButtonRef}
                      className="bg-transparent b-none pt-3"
                      onClick={(e) => {
                        e.preventDefault();
                        if (state != "") {
                          let resArr =
                            athlete?.athletes.length > 0 &&
                            athlete?.athletes?.filter((ath) => {
                              if (
                                ath.state
                                  .toLowerCase()
                                  .includes(state.toLowerCase())
                              ) {
                                return ath;
                              }
                            });
                          if (resArr.length > 0 && !resArr[0].blocked) {
                            setAthletes(resArr);
                          } else {
                            toast.warning("No Player Found!");
                          }
                        } else if (id != "") {
                          let resArr =
                            athlete.athletes.length > 0 &&
                            athlete?.athletes?.filter(
                              (ath) => ath.athleteID == id
                            );
                          if (resArr.length > 0 && !resArr[0].blocked) {
                            setAthletes(resArr);
                          } else {
                            toast.warning("No Player Found!");
                          }
                        } else if (searchByName != "") {
                          let resArr =
                            athlete.athletes.length > 0 &&
                            athlete.athletes.filter((ath) => {
                              let name = ath.first_name + " " + ath.last_name;
                              return (
                                name.toLowerCase() ==
                                  searchByName.toLowerCase() ||
                                ath.first_name.toLowerCase() ==
                                  searchByName.toLowerCase() ||
                                ath.last_name.toLowerCase() ==
                                  searchByName.toLowerCase()
                              );
                            });
                          if (resArr.length > 0 && !resArr[0].blocked) {
                            setAthletes(resArr);
                          } else {
                            toast.warning("No Player Found!");
                          }
                        } else {
                        }
                      }}
                    >
                      <img src={ClickHere} alt="Click Here" height="60px" />
                      <br />
                      <Label className="auth-desc-subtitle ml-0 mt-2 ">
                        Click to Search
                      </Label>
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <InstantChatModal isShow={isShow} toggleInstantChat={toggleInstantChat} />
      <ArrangeChatAppointmentModal
        isShow={isShowAppointment}
        toggleInstantChat={toggleInstantChatAppointment}
      />
    </>
  );
}

export default SearchForPlayer;
